import { STRUCTURED_CONTENT_FIELDS } from './structured-content-fields';

export const INTERACTIVE_MESSAGE_FIELDS = `
    id
    owner
    sharingStatus { id shareCount isPublished }
    contributionSource
    parentMessageId
    referencedMessageId
    threadRootMessageId
    email { subject from receivedAt preview hasOriginalHtml }
    laneKind
    aiRole
    threadReplyCount
    threadChatCount
    inChatSession
    activityAt
    threadMessageCount
    threadChatUpdatedAt
    threadMessageUpdatedAt
    threadActivityUpdatedAt
    title
    body
    rank
    createdAt
    updatedAt
    reminderAt
    eventArtifactId
    event { startDate endDate startTime endTime timeZone location rawDate needsReview }
    reminderUpdatedAt
    reminderFiredAt
    reminderCancelledAt
    reminderVersion
    reminderDeliveryType
    reminderMessage
    automaticReminderNeedsReview
    alerts {
        id
        offsetMinutes
        deliveryType
        firedAt
    }
    deletedAt
    image {
        url
        cdn_url
        thumbnail {
            sm
            md
            lg
            xl
            original
            compressed {
                sm
                md
                lg
                xl
                original
            }
        }
        name
        displayName
        type
        format
        size
        width
        height
        aspect_ratio
        public_id
    }
    file {
        url
        cdn_url
        thumbnail {
            sm
            md
            lg
            xl
            original
            compressed {
                sm
                md
                lg
                xl
                original
            }
        }
        name
        displayName
        type
        format
        size
        width
        height
        aspect_ratio
        duration
        mime
    }
    isCheckbox
    isChecked
    isStarred
    metadata {
        savedFrom { channel source method type }
        email { from subject receivedAt }
        highlight {
            color
            highlightId
        }
        audioProcessing {
            status
            outputFormat
            error
            startedAt
            completedAt
        }
        chatContext {
            isSyntheticConversation
            sources {
                sourceType
                messageId
                folderId
                sourceFolderTitle
                title
                body
                caption
                keywords
                ocrText
                suggestedFolderTitle
                sourceUrl
                publisher
                imageUrl
                fileName
                fileMime
                createdAt
            }
        }
    }
    folder {
        id
        title
        parent
        owner
        isPinned
        pinnedRank
        deletedAt
    }
    urlMeta {
        author
        date
        description
        article_url
        article_body
        article_pull_provider
        reddit_comments {
            author
            body
            score
            created_utc
            permalink
        }
        sourcePlatform
        sourceMetrics {
            score
            upvoteRatio
            commentCount
            createdUtc
            viewCount
            likeCount
            shareCount
            saveCount
            engagementRate
        }
        sourcePlatformMeta {
            reddit {
                subreddit
                permalink
                over18
                locked
                stickied
                postHint
                isGallery
            }
        }
        image
        image_asset_id
        gallery_images
        gallery {
            type
            image
            image_name
            image_asset_id
            media_asset_id
            media {
                public_id
                url
                cdn_url
                name
                displayName
                type
                format
                size
                aspect_ratio
                width
                height
                mime
                duration
                ocrText
                ocrExtracted
            }
            width
            height
            aspect_ratio
            media_url
            media_name
            media_cdn_url
            media_hls_url
            media_duration
            media_has_audio
        }
        image_cdn_url
        media_name
        media_asset_id
        media_audio_asset_id
        media_cdn_url
        media_url
        media_type
        media_width
        media_height
        media_duration
        media_has_audio
        media_audio_url
        media_hls_url
        logo
        publisher
        title
        url
        public_id
        image_name
        width
        height
        format
        aspect_ratio
        size
        thumbnail {
            sm
            md
            lg
            xl
            original
            compressed {
                sm
                md
                lg
                xl
                original
            }
        }
        author_image
        author_image_cdn_url
        author_image_public_id
        author_image_name
        author_image_size
        author_image_format
        author_image_aspect_ratio
        author_image_width
        author_image_height
        author_image_original
        author_image_thumbnail {
            sm
            md
            lg
            xl
            original
            compressed {
                sm
                md
                lg
                xl
                original
            }
        }
        quoted_url_meta {
            author
            date
            description
            article_url
            article_body
            article_pull_provider
            lang
            reddit_comments {
                author
                body
                score
                created_utc
                permalink
            }
            sourcePlatform
            sourceMetrics {
                score
                upvoteRatio
                commentCount
                createdUtc
                viewCount
                likeCount
                shareCount
                saveCount
                engagementRate
            }
            sourcePlatformMeta {
                reddit {
                    subreddit
                    permalink
                    over18
                    locked
                    stickied
                    postHint
                    isGallery
                }
            }
            image
            gallery_images
            gallery {
                type
                image
                image_name
                media {
                    public_id
                    url
                    cdn_url
                    name
                    displayName
                    type
                    format
                    size
                    aspect_ratio
                    width
                    height
                    mime
                    duration
                    ocrText
                    ocrExtracted
                }
                width
                height
                aspect_ratio
                media_url
                media_name
                media_cdn_url
                media_hls_url
                media_duration
                media_has_audio
            }
            image_cdn_url
            image_name
            media_url
            media_type
            media_width
            media_height
            media_duration
            media_has_audio
            media_audio_url
            media_hls_url
            logo
            publisher
            title
            url
            author_image
            author_image_cdn_url
            author_image_public_id
            author_image_name
            author_image_size
            author_image_format
            author_image_aspect_ratio
            author_image_width
            author_image_height
            author_image_original
        }
        embed {
            html
            script {
                src
                async
                charset
            }
        }
    }
    suggestedFolderTitle
    caption
    keywords
    ocrText
    transcript {
        text
        source
        status
        sourceUrl
        urlMetaIndex
        provider
        model
        createdAt
        updatedAt
        segments {
            start
            end
            text
        }
    }
    transcriptionSegments {
        start
        end
        text
    }
    ${STRUCTURED_CONTENT_FIELDS}
    entities {
        type
        name
        confidence
        artifactId
        enrichment {
            image
            width
            height
            aspect_ratio
            description
            year
            url
            source
        }
    }
    sourceHost
    sourceHosts
    sourceType
    sourceTypes
    canonicalSourceUrls
    sourceUrls
    stackIds
    primaryStackId
`;
